import React from 'react';
import WarningLightsIcon from 'mdi-react/WarningLightsIcon';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';
import SettingsApplicationsIcon from 'mdi-react/SettingsApplicationsIcon';
import AlarmLightIcon from 'mdi-react/AlarmLightIcon'
import DoctorIcon from 'mdi-react/DoctorIcon'
import HealthPredictionIcon from 'mdi-react/ClockAlertIcon'

export const Icons = ({ name }) => {
    switch(name) {
        case 'HEALTH_PREDICTION':
            return <HealthPredictionIcon />;
        case 'FAILURE_PREDICTION':
            return <WarningLightsIcon />;
        case 'FAULT_DIAGNOSIS':
            return <DoctorIcon />;
        case 'ANOMALY':
            return <AlarmLightIcon />;
        default:
            return null;
    }
}
